import PropTypes from 'prop-types';
import BaseComponent from "../../../../lib/components/BaseComponent";
import DialogNewCampaign from "../../../../lib/components/dialogs/DialogNewCampaign";
import T from "../../../model/system/text_translations/Translator";
import InputSearch from "../inputFields/InputSearch";
import {createRef} from "react";
import GF from "../../../../lib/utils/GF";
import CM from "../../../model/system/CM";
import Button from "../buttons/Button";
import {Card, CardContent, ToggleButton, ToggleButtonGroup} from "@mui/material";
import {Add, Circle} from "@mui/icons-material";
import Describe from "../../../../lib/model/service/dto/Describe";
import {toast} from "react-toastify";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import AddBoxSharpIcon from '@mui/icons-material/AddBoxSharp';

export default class CampaignCardNew extends BaseComponent {

  static STATUS_ALL = 0;
  static STATUS_EDITING = 1;
  static STATUS_MAINTENANCE = 2;
  static STATUS_PUBLISHED = 3;
  static STATUS_FINISHED = 4;

  constructor(props) {
    super(props);
    this.inputSearchRef = createRef();
    this.state = {
      filter: CampaignCardNew.STATUS_ALL, filterResetDisabled: true
    }
  }

  onNewButtonClick() {
    let self = this;
    CM.get().doJsonAjax(CM.get().getServiceUrl('campaign'), new Describe('Campaign', 'po2\\service\\dto\\Describe'),
      function(response) {
        if (response.success) {
          CM.get().setMainDialog(<DialogNewCampaign
            title='new Campaign Dialog'
            data={response.data.serviceDescription}
            onSaveButtonClick={(e) => self.onCampaignCreatButtonClick(e)}
            onCloseButtonClick={() => self.onDialogCloseButtonClick()}/>, self.onDialogCloseButtonClick)
        } else {
          toast.error('Leider konnte die Anfrage nicht bearbeitet werden!');
        }
      });
  }

  onCampaignCreatButtonClick(e) {
    if (this.props.reloadCampaigns !== undefined) {
      this.props.reloadCampaigns();
    }
  }

  onDialogCloseButtonClick = () => {
    CM.get().closeMainDialog();
    setTimeout(() => {
      this.onResetFiltersButtonClick(null);
    }, 1);
  }

  onChange(e, id, value) {
    if (GF.checkNotNull(this.props.onFilterInputChange)) {
      this.props.onFilterInputChange(e, id, value);
    }
    this.setState({filterResetDisabled: false});
  }

  onResetFiltersButtonClick(e) {
    this.inputSearchRef.current.clear();
    this.setState({filter: CampaignCardNew.STATUS_ALL, filterResetDisabled: true});
    this.props.onResetFilters(e);
  }

  onStatusFilterChange(e, statusFilter) {
    this.state.filter = statusFilter;
    if (this.props.onStatusFilterChange) {
      this.props.onStatusFilterChange(e, statusFilter);
    }
    this.setState({filter: statusFilter, filterResetDisabled: false});
  }

  render() {
    return <Card className='static mb-6 md:fixed' >
      <CardContent sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2}}>
        <Button size='large' onClick={(event) => this.onNewButtonClick(event)}>
          <VerticalLayout>
            <AddBoxSharpIcon sx={{height: '100px', width: '100px', borderRadius: '50%', padding: 0}} className={'self-center'} />
            {T.label_create_new_campaign()}
          </VerticalLayout>
        </Button>
        <InputSearch widthFull placeholder={T.label_search()} ref={this.inputSearchRef}
                     onChange={(e, id, value) => this.onChange(e, id, value)}
                     defaultValue={this.props.searchInputDefaultValue}/>
        <ToggleButtonGroup color='primary' orientation='vertical' value={this.state.filter} sx={{border: 'none'}}>
          <ToggleButton sx={{justifyContent: 'flex-start', border: 'none'}} value={CampaignCardNew.STATUS_EDITING}
                        onClick={(e) => this.onStatusFilterChange(e, CampaignCardNew.STATUS_EDITING)}>
            <Circle className='p-1 text-cn-color-blue-690 stroke-transparent'/>{T.label_filter_editing()}
          </ToggleButton>

          <ToggleButton sx={{justifyContent: 'flex-start', border: 'none'}} value={CampaignCardNew.STATUS_MAINTENANCE}
                        onClick={(e) => this.onStatusFilterChange(e, CampaignCardNew.STATUS_MAINTENANCE)}>
            <Circle className='p-1 text-amber-500 stroke-transparent'/>{T.label_filter_maintenance()}
          </ToggleButton>

          <ToggleButton sx={{justifyContent: 'flex-start', border: 'none'}} value={CampaignCardNew.STATUS_PUBLISHED}
                        onClick={(e) => this.onStatusFilterChange(e, CampaignCardNew.STATUS_PUBLISHED)}>
            <Circle className='p-1 text-cn-color-primary stroke-transparent'/>{T.label_filter_published()}
          </ToggleButton>

          <ToggleButton sx={{justifyContent: 'flex-start', border: 'none'}} value={CampaignCardNew.STATUS_FINISHED}
                        onClick={(e) => this.onStatusFilterChange(e, CampaignCardNew.STATUS_FINISHED)}>
            <Circle className='p-1 text-cn-color-static-red stroke-transparent'/>{T.label_filter_closed()}
          </ToggleButton>
        </ToggleButtonGroup>
        <Button disabled={this.state.filterResetDisabled} color='error'
                onClick={(e) => this.onResetFiltersButtonClick(e)}>
          {T.label_reset_filter()}
        </Button>
      </CardContent>
    </Card>;
  }
}

CampaignCardNew.propTypes = {
  statusFilterDefaultValue: PropTypes.oneOf([0, 1, 2, 3, 4]),
  onStatusFilterChange: PropTypes.func.isRequired,
  onFilterInputChange: PropTypes.func.isRequired,
  searchInputDefaultValue: PropTypes.string,
  reloadCampaigns: PropTypes.func,
  onResetFilters: PropTypes.func,
}
